'use client';
import cn from 'classnames';
import Button from '@/components/common/Button/Button';
import Image from 'next/image';
import Text from '@/components/common/Text/Text';

import AppleAppStoreBadge from 'public/img/icon/apple-app-store-badge.svg';
import CloseIcon from 'public/img/icon/close.svg';
import VivrelleIcon from 'public/img/logo/vivrelle-logo-in-pink-squircle.png';

import './AppBanner.style.scss';

type AppBannerProps = {
  className?: string;
  handleCloseBanner?: () => void;
};

function AppBanner(props: AppBannerProps) {
  const { className = '', handleCloseBanner } = props;

  return (
    <div className={cn('AppBanner', className)}>
      <Button
        onClick={handleCloseBanner}
        variant='icon'
      >
        <Image
          alt='Close App banner icon'
          src={CloseIcon}
          height={20}
          width={20}
        />
      </Button>

      <div className='AppBanner-details'>
        <Image
          src={VivrelleIcon}
          height={58}
          width={58}
          alt='Vivrelle icon'
          priority
        />
        <Text
          uppercase
          variant='title-xxs-500'
        >
          Get the app
        </Text>
      </div>

      <a
        href='https://apps.apple.com/ca/app/vivrelle/id1542044957'
        rel='noopener noreferrer'
        target='_blank'
      >
        <Image
          src={AppleAppStoreBadge}
          height={40}
          width={121}
          alt='Download the Vivrelle app on the Apple App Store'
          priority
        />
      </a>
    </div>
  );
}

export default AppBanner;
